import { Form, Select } from "antd";
import { getConfigAppPartType } from "../../utils";
import { AppPartType } from "../../AppForm/types";
import { APP_PART_TYPES } from "../../AppForm/constants";
import { Styles } from "./styled";
interface IProps {
  isDisable?: boolean;
  preview?: boolean;
  item: AppPartType;
  parentItem?: AppPartType;
  style?: React.CSSProperties;
  isTable?: boolean;
  nameItem: string;
  styleColor?: React.CSSProperties;
  className?: string;
}

const CommonChoose = (props: IProps) => {
  const {
    item,
    isDisable,
    nameItem,
    style,
    preview,
    isTable,
    styleColor = {},
    className,
  } = props;
  const { isHiddenLabel, labelText, appPartType } = getConfigAppPartType(item);
  let mode: "multiple" | "tags" | undefined;
  if (appPartType === APP_PART_TYPES.MULTI_CHOICE) {
    mode = "multiple";
  }
  const form = Form.useFormInstance();
  const value = form.getFieldValue(nameItem);
  const isShowOnlyValue = !preview && isTable && isDisable;
  const valueText = mode === "multiple" ? (value || []).join(",") : value;

  return (
    <Styles
      style={style}
      id={item.id}
      color={styleColor?.color}
      background={styleColor?.background}
    >
      <div className="value_text_container">
        {isShowOnlyValue && value && valueText}
      </div>
      <Form.Item
        hidden={isShowOnlyValue}
        label={
          isHiddenLabel ? (
            <div></div>
          ) : (
            <div className="no-wrap-text" title={labelText}>
              {labelText}
            </div>
          )
        }
        name={nameItem}
        rules={[
          {
            required: item.is_required_field,
            message: `必須項目です`,
          },
        ]}
        validateTrigger="onBlur"
        className={className}
      >
        <Select mode={mode}>
          {(item.item_config_data?.options || []).map((option, i) => {
            return (
              <Select.Option
                key={i}
                value={option?.text}
                className="custom-option"
              >
                {option.text}
              </Select.Option>
            );
          })}
        </Select>
      </Form.Item>
    </Styles>
  );
};
export default CommonChoose;
